import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function InvMenu(){
    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Investigation Master Setting</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/add-radio"><button type="button" className="btn btn"><span >Add Investigation
                    </span></button></a></div>
                    <div className="btn-group">
                    <a href="/start-dicom"><button type="button" className="btn btn"><span >Dicom Service Start</span></button></a></div>
                    <div className="btn-group">
                    <a href="/ohif"><button type="button" className="btn btn"><span >PACS Viewer</span></button></a></div>
                    </div>

                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Investigations</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/inv-view"><button type="button" className="btn btn"><span >Investigation Entry</span></button></a></div>
                    <div className="btn-group">
                    <a href="/inv-files-view"><button type="button" className="btn btn"><span >View File Upload</span></button></a></div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Investigation Reports</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/collection-inv"><button type="button" className="btn btn"><span >Collection Report</span></button></a></div>

                    </div>
                    </div>
               </div>
            </div>
        </section>
    )
}

export default InvMenu;